module.exports = __webpack_public_path__ + "media/application/images/projects/images/morocco_hills-07ad5c806ea07792faa3c7996eb0b335.jpg";